import { api } from '@/services';

export default {
  async fetchValoresAduaneiros({ dispatch, commit }, payload) {
    const { codigoProcesso, codigoFilial } = payload;
    try {
      const response = await api.get(`/processo/formacaoValorAduaneiro/${codigoProcesso}/filial/${codigoFilial}`);
      commit('SET_VALORES_ADUANEIROS', response.data.registros);
    } catch (err) {
      dispatch(
        'setGlobalError',
        'Não foi possível recuperar as informações do câmbio',
        { root: true },
      );
    }
  },
  async cleanValoresAduaneiros({ commit }) {
    commit('SET_VALORES_ADUANEIROS', []);
  },
};
